// Add your JS customizations here
import 'tocbot/src/js/index';

document.addEventListener("DOMContentLoaded", function() {
	window.addEventListener('scroll', function () {
		if (window.scrollY > 50) {
			document.querySelector('#paratik-navbar-head').classList.add('sticky-header');
			// add padding top to show content behind navbar
			var navbar_height = document.querySelector('#paratik-navbar-head').offsetHeight;
			document.body.style.paddingTop = '0px';
		} else {
			document.querySelector('#paratik-navbar-head').classList.remove('sticky-header');
			// remove padding top from body
			document.body.style.paddingTop = '0';
		}
		if (window.scrollY > 250 && document.querySelector("#topBtn") !== null ) {
			document.querySelector("#topBtn").style.display = 'block';
		}

	});

});
jQuery('#topBtn').on('click', function (e) {
	e.preventDefault();
	document.body.scrollTop = 0;
	document.documentElement.scrollTop = 0;
});
function scrollIfNeeded(element, container) {
    var eot = element.offsetTop - 75;
  if (eot < container.scrollTop) {
    container.scrollTop = eot;
  } else {
    const offsetBottom = element.offsetTop + element.offsetHeight;
    const scrollBottom = container.scrollTop + container.offsetHeight;
    if (offsetBottom > scrollBottom) {
      container.scrollTop = offsetBottom - container.offsetHeight;
    }
  }
}
tocbot.init({
	// Where to render the table of contents.
	tocSelector: '.toc-content',
	// Where to grab the headings to build the table of contents.
	contentSelector: '.maincontent',
	// Which headings to grab inside of the contentSelector element.
	headingSelector: 'h2, h3',
	// For headings inside relative or absolute positioned containers within content.
	hasInnerContainers: true,
	extraListClasses: 'ps-3',
	headingsOffset: 100,
	scrollSmoothOffset: -100,
	scrollEndCallback: function (e) {

		scrollIfNeeded(document.querySelector('.toc-list-item.is-active-li'), document.querySelector('.toc-list.submenu'));
	},
	onClick: function (e) {
		if(window.innerWidth <= 768) {
			var mtocE = document.querySelector('#tocmcol');
			var mtoc = bootstrap.Collapse.getOrCreateInstance(mtocE).hide();
		}
	},


});

var timeout = false, // holder for timeout id
	delay = 250, // delay after event is "complete" to run callback
	calls = 0;
// window.resize callback function
function getDimensions() {
	let w = window.innerWidth;
	if(w <= 768) {
		tocbot.destroy();
		tocbot.init({
			// Where to render the table of contents.
			tocSelector: '.mobil-sideBar-icindekiler .toc-content',
			// Where to grab the headings to build the table of contents.
			contentSelector: '.maincontent',
			// Which headings to grab inside of the contentSelector element.
			headingSelector: 'h2, h3',
			// For headings inside relative or absolute positioned containers within content.
			hasInnerContainers: true,
			extraListClasses: 'ps-3 ssmenu',
			headingsOffset: 600,
			scrollSmoothOffset: -600,
			scrollEndCallback: function (e) {

				scrollIfNeeded(document.querySelector('.toc-list-item.is-active-li'), document.querySelector('.toc-list.ssmenu'));
			},
			onClick: function (e) {
				if(window.innerWidth <= 768) {
					var mtocE = document.querySelector('#tocmcol');
					var mtoc = bootstrap.Collapse.getOrCreateInstance(mtocE).hide();
				}
			},

		});

	}else {
		tocbot.destroy();
		tocbot.init({
			// Where to render the table of contents.
			tocSelector: '.masa-icindekiler .toc-content',
			// Where to grab the headings to build the table of contents.
			contentSelector: '.maincontent',
			// Which headings to grab inside of the contentSelector element.
			headingSelector: 'h2, h3',
			// For headings inside relative or absolute positioned containers within content.
			hasInnerContainers: true,
			extraListClasses: 'ps-3 ssmenu',
			headingsOffset: 100,
			scrollSmoothOffset: -100,
			scrollEndCallback: function (e) {
				scrollIfNeeded(document.querySelector('.toc-list-item.is-active-li'), document.querySelector('.toc-list.ssmenu'));
	},
			onClick: function (e) {
				if(window.innerWidth <= 768) {
					var mtocE = document.querySelector('#tocmcol');
					var mtoc = bootstrap.Collapse.getOrCreateInstance(mtocE).hide();
				}
			},

		});
	}
	calls += 1;
}
// window.resize event listener
window.addEventListener('resize', function() {
	// clear the timeout
	clearTimeout(timeout);
	// start timing for event "completion"
	timeout = setTimeout(getDimensions, delay);
});
getDimensions();

jQuery('a[data-ulke]').each( function() {
	var dat = jQuery(this).attr('data-ulke');
	jQuery(this).on('click', (e) => {
		e.preventDefault();
		jQuery('.yurtdisicatfilter').html('<div class="d-flex justify-content-center"><div class="spinner-border text-center" role="status" style="height: 150px;width: 150px;">\n' +
			'  <span class="visually-hidden">Loading...</span>\n' +
			'</div></div>');
		jQuery([document.documentElement, document.body]).animate({
			scrollTop: jQuery(".yurtdisicatfilter").offset().top
		}, 500);
		jQuery.ajax({
			type : "post",
			url : '/wp-admin/admin-ajax.php',
			data : {action: "catfiltre", cat_id : dat, pcat_id: '181'},
			success: function(response) {
				jQuery(".yurtdisicatfilter").html(response);
			}
		})
	});
});
jQuery('a[data-market]').each( function() {
	var dat = jQuery(this).attr('data-market');
	jQuery(this).on('click', (e) => {
		e.preventDefault();
		jQuery('.fiyatcatfilter').html('<div class="d-flex justify-content-center"><div class="spinner-border text-center" role="status" style="height: 150px;width: 150px;">\n' +
			'  <span class="visually-hidden">Loading...</span>\n' +
			'</div></div>');
		jQuery([document.documentElement, document.body]).animate({
			scrollTop: jQuery(".fiyatcatfilter").offset().top
		}, 500);
		jQuery.ajax({
			type : "post",
			url : '/wp-admin/admin-ajax.php',
			data : {action: "catfiltre", cat_id : dat, pcat_id: '286' },
			success: function(response) {
				jQuery(".fiyatcatfilter").html(response);

			}
		})
	});
});
jQuery('a[data-fiyat]').each( function() {
	var dat = jQuery(this).attr('data-fiyat');
	jQuery(this).on('click', (e) => {
		e.preventDefault();
		jQuery('.fiyatcatfilter').html('<div class="d-flex justify-content-center"><div class="spinner-border text-center" role="status" style="height: 150px;width: 150px;">\n' +
			'  <span class="visually-hidden">Loading...</span>\n' +
			'</div></div>');
		jQuery([document.documentElement, document.body]).animate({
			scrollTop: jQuery(".fiyatcatfilter").offset().top
		}, 500);
		jQuery.ajax({
			type : "post",
			url : '/wp-admin/admin-ajax.php',
			data : {action: "catfiltre", cat_id : dat, pcat_id: '286' },
			success: function(response) {
				jQuery(".fiyatcatfilter").html(response);
			}
		})
	});
});
jQuery('#genelfiyatfiltre').on('click', function(e) {
	e.preventDefault();
	jQuery([document.documentElement, document.body]).animate({
		scrollTop: jQuery(".caticyazi").offset().top
	}, 500);
});
//! drop open-close
jQuery(document).ready(function( $ ) {
	"use strict";
	$(window).scroll(function () {
		if ($(this).scrollTop() > 600 ) {
			if($("ins#footad").data("ad-status") === 'filled') {
				$('#footerAd-body').css("opacity", "1");
			}
		}
	});
	$("#footerAd-body .arrow").click(function () {
			$('#footerAd-body').remove();
	});

	//reklam
	$(".footerAd .close").click(function() {
		$(".footerAd").fadeOut(function() {
			$(this).remove();
		});
	});
} );

const aramacC = document.getElementById('paratikaramac');
aramacC.addEventListener('shown.bs.collapse', event => {
	document.getElementById("aramac").focus();
})
